import { createFileRoute, Outlet } from '@tanstack/react-router';
import AppHeader from '../../components/navBar/AppHeader';
import { HeaderSlotProvider } from '../../components/navBar/HeaderSlotContext';

export const Route = createFileRoute('/_authenticated/_navbar')({
  component: NavbarLayout,
});

function NavbarLayout() {
  return (
    <HeaderSlotProvider>
      <AppHeader />
      <Outlet />
    </HeaderSlotProvider>
  );
}
